import { marginBottom, EmptyArtwork, unit, breakpoints } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const TextContainer = styled.div `
  display: flex;
  flex-direction: column;
  ${marginBottom(4)};
`;
export const Container = styled.div `
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  height: 100%;
`;
export const StyledEmptyArtwork = styled(EmptyArtwork) `
  width: 100%;
  max-width: 20rem;
`;
export const PaginationContainer = styled.div `
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: center;
  padding: ${unit('2xl')} 0;

  ${breakpoints.md} {
    justify-content: flex-start;
  }
`;
export const AlertContainer = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`;
